import { withErrorBoundary } from '@sentry/react'
import { useContext } from 'react'

import CollapseIcon from 'src/assets/close.svg'
import ExpandIcon from 'src/assets/menu.png'
import ORNALogo from 'src/assets/orna_transparent_text_white_logo.png'
import SentryFallback from 'src/components/common/SentryFallback'
import { NavigatorContext } from 'src/context/navigatorContext'
import SimulationCtx from 'src/context/simulationCtx'
import useModuleNavbar from 'src/utils/hooks/use-module-navbar'

import './header.css'
import HelpCenter from './helpCenter'
import Notifications from './notifications'
import ProfileDropdown from './profileDropdown'
import SampleData from './sampleData'

const Header = () => {
    const { isEnabled: isSimulationEnabled } = useContext(SimulationCtx)

    const { navbar } = useModuleNavbar()

    const {
        overlayVisible,
        setOverlayVisible,
        toggleSidebar,
        sidebarCollapsed,
        setSidebarCollapsed,
    } = useContext(NavigatorContext)

    return (
        <>
            {overlayVisible && (
                <div
                    className={`fixed top-0 left-0 right-0 bottom-0 z-[998] bg-black opacity-50 md:hidden`}
                    onClick={() => {
                        setOverlayVisible(false)
                        toggleSidebar(false)
                    }}
                />
            )}
            <div
                style={{ zIndex: 1000 }}
                className="header-container h-[var(--navbar-height)] border-b border-neutral-gray-700 shadow-md 2xl:h-16"
            >
                <div className="flex h-full w-full items-center justify-between lg:relative lg:gap-4">
                    <div className="flex items-center gap-5 pl-4 lg:pl-8">
                        <img
                            src={ORNALogo}
                            className="h-7 object-contain 2xl:h-9"
                            alt="orna logo"
                        />
                        <div className="flex cursor-pointer items-center justify-center">
                            <img
                                className="aspect-square w-4"
                                src={
                                    sidebarCollapsed ? ExpandIcon : CollapseIcon
                                }
                                alt="menu"
                                onClick={() => {
                                    setSidebarCollapsed(!sidebarCollapsed)
                                }}
                            />
                        </div>
                        {/*NOTE: module feature navigation*/}
                        <div>{navbar}</div>
                    </div>

                    <div className="flex items-center justify-center">
                        <div className="flex items-center pr-4">
                            <SampleData />
                            <div className="flex gap-x-4">
                                <HelpCenter />
                                <Notifications />
                            </div>

                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
                {isSimulationEnabled && (
                    <div className="flex h-[46px] w-full items-center bg-green-400">
                        <div className="marquee flex-grow">
                            <span className="lg:text-lg">
                                You are in Simulation Mode
                            </span>
                        </div>
                        {/* NOTE: Container for button to access backstage for the current simulation*/}
                        <div
                            id="backstage-access-button"
                            className="my-1 ml-auto mr-1 inline-flex shrink-0"
                        ></div>
                    </div>
                )}
            </div>
        </>
    )
}

export default withErrorBoundary(Header, {
    fallback: <SentryFallback />,
})
